import { rem } from 'design-system/values';
export const eachCharacterWidth = rem(10);
export const horizontalPadding = rem(8 * 2);
